/**
 * @generated SignedSource<<3b5c4887dcfbf9ed0e18657966974b41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssignmentMonitoringQuery$variables = {
  assignmentId: string;
};
export type AssignmentMonitoringQuery$data = {
  readonly assignment: {
    readonly id: string;
    readonly skill: {
      readonly code: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly skillAncestries: ReadonlyArray<{
        readonly ancestorSkill: {
          readonly code: string | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly studentSkillAssignments: ReadonlyArray<{
      readonly id: string;
      readonly skill: {
        readonly id: string;
      } | null | undefined;
      readonly skillAssessment: {
        readonly id: string;
        readonly score: number;
      } | null | undefined;
      readonly submittedOn: any | null | undefined;
      readonly user: {
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly assignmentProgressPercentages: {
    readonly supportSkillAllCompleted: number;
    readonly supportSkillPending: number;
    readonly supportSkillSomeInProgress: number;
    readonly targetSkillFinished: number;
    readonly targetSkillNotStarted: number;
  };
};
export type AssignmentMonitoringQuery = {
  response: AssignmentMonitoringQuery$data;
  variables: AssignmentMonitoringQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assignmentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "assignmentId",
    "variableName": "assignmentId"
  }
],
v2 = {
  "alias": null,
  "args": (v1/*: any*/),
  "concreteType": "AssignmentProgressPercentages",
  "kind": "LinkedField",
  "name": "assignmentProgressPercentages",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportSkillAllCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportSkillPending",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportSkillSomeInProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetSkillFinished",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetSkillNotStarted",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "skillRelevanceIds": [
        "SkillRelevanceNode:3"
      ]
    }
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "ancestorSkill",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StudentSkillAssignmentNode",
  "kind": "LinkedField",
  "name": "studentSkillAssignments",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submittedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StudentSkillAssessmentNode",
      "kind": "LinkedField",
      "name": "skillAssessment",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicUserId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillNode",
      "kind": "LinkedField",
      "name": "skill",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentMonitoringQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignmentNode",
        "kind": "LinkedField",
        "name": "assignment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "SkillAncestryNode",
                "kind": "LinkedField",
                "name": "skillAncestries",
                "plural": true,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": "skillAncestries(filter:{\"skillRelevanceIds\":[\"SkillRelevanceNode:3\"]})"
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentMonitoringQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignmentNode",
        "kind": "LinkedField",
        "name": "assignment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "SkillAncestryNode",
                "kind": "LinkedField",
                "name": "skillAncestries",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": "skillAncestries(filter:{\"skillRelevanceIds\":[\"SkillRelevanceNode:3\"]})"
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4e04b637feafe6f906f930c4692b5a2",
    "id": null,
    "metadata": {},
    "name": "AssignmentMonitoringQuery",
    "operationKind": "query",
    "text": "query AssignmentMonitoringQuery(\n  $assignmentId: ID!\n) {\n  assignmentProgressPercentages(assignmentId: $assignmentId) {\n    supportSkillAllCompleted\n    supportSkillPending\n    supportSkillSomeInProgress\n    targetSkillFinished\n    targetSkillNotStarted\n  }\n  assignment(assignmentId: $assignmentId) {\n    id\n    skill {\n      id\n      name\n      code\n      skillAncestries(filter: {skillRelevanceIds: [\"SkillRelevanceNode:3\"]}) {\n        ancestorSkill {\n          id\n          name\n          code\n        }\n        id\n      }\n    }\n    studentSkillAssignments {\n      id\n      submittedOn\n      skillAssessment {\n        id\n        score\n      }\n      user {\n        id\n        firstName\n        lastName\n        publicUserId\n      }\n      skill {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "27e2c8bf6e91e381fdd0cb030f083106";

export default node;
